import Page from "../../framework/Page";
import View from "../../framework/View";
import PartyTarget from "../../../model/character/PartyTarget";
import LayerDescription from "../../../model/grid/LayerDescription";
import NumberFormatter from "../../../util/NumberFormatter";
import { Images } from "../../../Images";
import Statistics from "../../../model/statistics/Statistics";
import { LayerDescriptionArray } from "../../../model/grid/LayerDescriptions";

export default class TerrainLayerProgress extends View {
    /**
     * @param {string} parentId 
     * @param {string} elementId 
     * @param {PartyTarget} partyTarget
     * @param {Statistics} statistics 
     */
    constructor(parentId, elementId, partyTarget, statistics) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {PartyTarget}
         */
        this.partyTarget = partyTarget;
        /**
         * @constant
         * @type {Statistics}
         */
        this.statistics = statistics;

        /**
         * @type {LayerDescription}
         */
        this.displayedLayerDescription = null;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {HTMLElement}
         */
        this.imgElement = null;

        /**
         * @type {HTMLElement}
         */
        this.titleElement = null;

        /**
         * @type {HTMLElement}
         */
        this.progressElement = null;

        /**
         * @type {string}
         */
        this.displayedTitle = null;

        /**
         * @type {string}
         */
        this.displayedDescription = null;
        /**
         * @type {HTMLElement}
         */
        this.descriptionElement = null;

        /**
         * @type {string}
         */
        this.displayedIconFileName = null;

        /**
         * @type {number}
         */
        this.displayPercent = -1;

        /**
         * @type {number}
         */
        this.displayMaxDepth = -1;

    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('UnlockTerrainLayerView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'terrain-layer-progress-outer');

        const bodyElement = Page.createElement('div', this.mainElement, null, 'mined-upgrade-button-body');

        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', bodyElement, this.elementId + '_text', 'mined-upgrade-title-description-container');

        // <img src="images/miner_icon_51x48.png"/>
        // Use the 'icon-container' style here to force the image to be 40x40.
        this.imgElement = Page.createElement('img', iconElement, null, 'icon-container'); 
        this.imgElement.src = Images.pick;

        this.titleElement = Page.createElement('div', titleDescriptionContainer, null, null);
        this.titleElement.innerHTML = '';

        // Create the description element.
        this.descriptionElement = Page.createElement('div', titleDescriptionContainer, null, 'mined-upgrade-button-description');
        this.descriptionElement.innerHTML = '';

        // Progress bar overlay for unlock terrain layer upgrade.
        this.progressElement = Page.createElement('div', this.mainElement, null, 'terrain-layer-progress-slider');

        //////////////////////////////////////
        // Setup initial visibility
        //////////////////////////////////////

        // Initialize the upgrade button as visible.
        this.setInitialVisibility(true);

        super.initializeView();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }


    /**
     * @private
     * @returns {string}
     */
    generateDescription() {
        return 'Depth: ' + NumberFormatter.formatNumber(this.statistics.maxDepth) + ' / ' + NumberFormatter.formatNumber(this.displayedLayerDescription.maxDepth);
    }

    /**
     * @override
     */
    updateViewContents() {

        const layerDescription = this.partyTarget.layerDescription;
        // const nextLayerDescription = this.partyTarget.nextLayerDescription;
        const maxDepth = this.statistics.maxDepth;

        // if (!nextLayerDescription) {
        //     return;
        // }

        if (this.displayedLayerDescription !== layerDescription || this.displayMaxDepth != maxDepth) {
            this.displayedLayerDescription = layerDescription;
            this.displayMaxDepth = maxDepth;

            const nominalIndex = layerDescription.nominalIndex;
            if (nominalIndex > 0) {
                const finalLayer = LayerDescriptionArray[LayerDescriptionArray.length - 1];
                this.titleElement.innerHTML = layerDescription.name + ' (' + nominalIndex + '/' + finalLayer.nominalIndex + ')';
            }
            else {
                this.titleElement.innerHTML = layerDescription.name;
            }

            this.descriptionElement.innerHTML = this.generateDescription();
        }

        // sanity check
        if (!this.displayedLayerDescription) {
            return;
        }

        const iconFileName = this.displayedLayerDescription.iconFileName;
        if (this.displayedIconFileName !== iconFileName) {
            this.displayedIconFileName = iconFileName;
            this.imgElement.src = 'images/layers/' + iconFileName;
        }

        ////////////////////////////////////////
        // Progress Percent
        ////////////////////////////////////////

        const percent = layerDescription.getDepthPercent(maxDepth);

        if (percent != this.displayPercent) {
            this.displayPercent = percent;

            // The red progress bar should disappear at 100%
            if (percent >= 100) {
                this.progressElement.style.width = 0 + 'px';
            }
            else {
                this.progressElement.style.width = percent + '%';
            }
        }
    }

}